<section class="pt-[40px] xl:pt-[56px] pb-[60px] xl:pb-[80px]">
  <div class="container flex lg:flex-row flex-col lg:gap-[20px] xl:gap-x-[36px]">
    <div
      class="max-w-[500px] mx-auto flex flex-col flex-1 self-start xl:self-stretch border border-solid border-white/30 rounded-[4px] bg-[#242629]"
    >
      <div class="flex max-w-[499px] mx-auto items-center">
        <img src="./images/contacts-photo.png" alt="contacts" />
      </div>
      <div class="flex flex-col grow shrink-0 contacts-bg">
        <div
          class="flex flex-col xl:px-[28px] xl:pt-[16px] px-[12px] pt-[16px] xl:mb-[24px] mb-[24px]"
        >
          <div class="flex flex-col">
            <span class="text-[12px] text-white/50 xl:tracking-[0.2px] tracking-[0.1px]">
              Legal Entity in UAE:
            </span>
            <p class="text-[16px] font-medium text-white/50 mt-[3px] xl:mt-[2px] tracking-[-0.4px]">
              STAR COMPLIANCE CYBER RISK MANAGEMENT <br class="xl:block hidden" />
              SERVICES L.L.C
            </p>
          </div>
          <div class="flex flex-col lg:mt-[20px] mt-[16px]">
            <span class="text-[12px] text-white/50 xl:tracking-[0.2px] tracking-[0.1px]">
              License number:
            </span>
            <p class="text-[16px] font-medium text-white/50 mt-[4px] tracking-[0.6px]">1135542</p>
          </div>
        </div>
        <div class="w-full flex flex-col justify-end px-[12px] xl:px-[28px] pb-[16px] xl:pb-[24px]">
          <span
            class="text-[23px] font-medium text-white/50 leading-[1.4] text-[#75797D] tracking-[0.54px]"
          >
            Let’s Connect
          </span>
          <span class="mt-[16px] text-[14px] leading-[1.4] text-[#75797D] tracking-[0.38px]">
            Feel free to contact any time <br class="md:hidden" />
            in case of emergency.
          </span>
          <div class="grid grid-cols-2 grid-rows-2 gap-x-[12px] gap-y-[16px] mt-[16px]">
            <a
              href="https://wa.me/971561829077"
              target="_blank"
              class="row-start-1 min-h-[60px] btn bg-[#13B951] text-white gap-[8px] tracking-[0.6px]"
            >
              <mat-icon svgIcon="whatspp-filled-icon" class="text-white"></mat-icon>
              WhatsApp
            </a>
            <a
              href="https://t.me/AMLOfficer_Support"
              target="_blank"
              class="row-start-1 btn min-h-[60px] bg-[#0088CC] text-white gap-[8px] tracking-[0.6px]"
            >
              <mat-icon svgIcon="tg-filled-icon" class="text-white"></mat-icon>
              Telegram
            </a>
            <a
              href="tel:+971561829077"
              target="_blank"
              class="col-span-2 btn min-h-[60px] gap-[10px] bg-[#B50600] text-white tracking-[0.6px]"
            >
              <mat-icon svgIcon="phone-filled-icon" class="text-white"></mat-icon>
              Call Now
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-1 flex flex-col mt-[52px] lg:mt-0">
      <h1 class="text-[26px] lg:text-[30px] xl:text-[36px] font-bold text-white leading-[1]">
        Contact AMLOfficer
      </h1>
      <div class="flex flex-col mt-[24px] xl:mt-[33px]">
        <span
          class="text-[18px] lg:text-[20px] xl:text-[24px] text-[#9A9A9A] leading-[1] font-base tracking-[-.4px] xl:tracking-[-1px]"
        >
          POWERED BY
        </span>
        <div class="flex items-center max-w-[166px] md:max-w-[200px] xl:max-w-[248px] mt-[19px]">
          <img src="./images/svg/starcompliance-logo.svg" alt="logo" />
        </div>
      </div>
      <div class="flex flex-col mt-[24px]">
        <span
          class="text-[20px] xl:text-[24px] leading-[1] font-medium text-white tracking-[0.6px] xl:tracking-[0.3px]"
        >
          Who are we?
        </span>
        <p
          class="text-[16px] md:text-[18px] leading-[1.8] text-[#C0C0C0] mt-[14px] xl:mt-[19px] tracking-[0.22px] xl:tracking-[0.18px]"
        >
          AMLOfficer was founded by StarCompliance, a leader in compliance and risk management. We
          are a specialized service that checks cryptocurrency better than anyone else on the
          market. Our expertise lies in compliance and the perfect monitoring of crypto activity.
        </p>
      </div>
      <div class="flex flex-col xl:mt-[24px] mt-[19px]">
        <span
          class="text-[20px] xl:text-[24px] leading-[1] font-medium text-white tracking-[0.88px] xl:tracking-[0.68px]"
        >
          What do we do?
        </span>
        <p
          class="text-[16px] md:text-[18px] leading-[1.8] text-[#C0C0C0] mt-[14px] xl:mt-[19px] tracking-[0.22px] xl:tracking-[0.18px]"
        >
          We provide businesses with the ability to seamlessly integrate compliance checks without
          additional costs. Our solution is unique: not only are these checks completely free for
          users, but they also create additional income streams for businesses that implement them.
        </p>
      </div>
      <div class="flex flex-col xl:mt-[24px] mt-[19px]">
        <span
          class="text-[20px] xl:text-[24px] leading-[1] font-medium text-white tracking-[0.76px] xl:tracking-[0.54px]"
        >
          Why is this important?
        </span>
        <p
          class="text-[16px] md:text-[18px] leading-[1.8] text-[#C0C0C0] mt-[14px] xl:mt-[19px] tracking-[0.22px] xl:tracking-[0.18px]"
        >
          Because user safety comes first. AML (Anti-Money Laundering) security in crypto is
          paramount, and our service ensures maximum protection. By combining compliance expertise,
          advanced monitoring, and financial benefits, we help create a safer and more sustainable
          cryptocurrency ecosystem.
        </p>
      </div>
    </div>
  </div>
</section>
